import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Checkbox from "@material-ui/core/Checkbox";
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
import BBLogo from "../assets/images/BreachBits_full_medres_transparent_fordarkbackground.png"
import {
    addNewUserSelfManaged,
    registerUserAction,
    showAuthLoader,
} from 'actions/Auth';
import qs from 'qs';
import {useForm} from "react-hook-form";
import {FormControlLabel, FormHelperText,} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import {BREACHBITS_SLA} from "./SLA";
import URLSearchParams from "url-search-params";

var pjson = require('../../package.json'); //to display version number

const RegisterUser = (props) => {

    const {location} = props;

    const dispatch = useDispatch();
    const {token, authUser} = useSelector(({auth}) => auth);
    const {loader} = useSelector(({auth}) => auth);
    const {didJustRegisterUser} = useSelector(({auth}) => auth.appMisc);


    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [signSLA, setSignSLA] = useState(false);
    const [sla, setSLA] = useState(BREACHBITS_SLA);

    //variables grabbed form the URL parameters
    const urlProfileId = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).profile : null;
    //if the profileId was passed in the URL, grab it and set it as initial state
    const [profileId, setProfileId] = useState(urlProfileId ? urlProfileId : null);

    const urlFirstName = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).firstName : null;
    const [firstName, setFirstName] = useState(urlFirstName ? urlFirstName : null);

    const urlLastName = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).lastName : null;
    const [lastName, setLastName] = useState(urlLastName ? urlLastName : null);

    const urlEmail = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).email : null;
    const [email, setEmail] = useState(urlEmail ? urlEmail : null);

    const urlPromoCode = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).promo : null;
    const [promoCode, setPromoCode] = useState(urlPromoCode ? urlPromoCode : null);

    const urlRefCode = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).ref : null;
    const [refCode, setRefCode] = useState(urlRefCode ? urlRefCode : null);

    const urlSetHomePage = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).homepage : null;
    const [homepage, setHomepage] = useState(urlSetHomePage ? urlSetHomePage : null);

    const { register, handleSubmit, errors } = useForm();

    const preflightLinkedInAd = () => {
        console.group("Attempting to check for LinkedIn Conversion Tracker Presence")
        const params = new URLSearchParams(props.location.search);
        console.log("params", params);

        //check that the URL has the param adRef=LI
        if(params.has("adRef")){
            console.log("adRef param was found");
            const adRef = params.get("adRef")
            //if the adRef is LI, then its from LinkedIn
            if(adRef && adRef === "LI") {
                console.log("adRef appears to be LI", "adRef", adRef);
                console.log("Preflight complete. This page appears to have a linkedIn URL parameter.");
                console.groupEnd();
                return true;
            } else {
                console.log("adRef found, but is not LI", "adRef", adRef);
                console.info("Preflight failed. This page does not appear to have a linkedIn URL parameter.");
                console.groupEnd();
                return false;
            }
        } else {
            console.log("adRef missing from params", "params", params);
            console.info("Preflight failed. This page does not appear to have a linkedIn URL parameter.");
            console.groupEnd();
            return false;
        }
    }

    const detectAndTrackLinkedInAd = () => {
        console.group("Attempting to check for LinkedIn Event Conversion via form submission")

            if(preflightLinkedInAd()) {
                console.log("preflightLinkedInAd reports that preflight is good to go");
                console.log("Invoking the linkedIn Event Tracker for a submitted registration form.");
                //invoke the event to communicated with the LinkedIn conversion
                window.lintrk('track', { conversion_id: 9365274 });
                console.groupEnd();
            } else {
                console.error("Attempted to invoke LinkedIn tracker but preflight failed");
                console.groupEnd();
            }
        }

    const onSubmit = data => {
        //communicate with the conversion tracker if applicable.
        detectAndTrackLinkedInAd();

        dispatch(showAuthLoader());

        if(profileId){
            dispatch(registerUserAction({
                "firstName": data.firstName,
                "lastName": data.lastName,
                "email": data.email,
                "password": data.password,
                "username": data.username,
                "profileId": data.profileId,
                "signSLA": data.signSLA,
                "refCode": refCode,
                "promoCode": promoCode,
                "homepage": homepage,
            }));
        } else {
            dispatch(addNewUserSelfManaged(
                data.firstName,
                data.lastName,
                data.email,
                data.password,
                data.username,
                data.signSLA,
                refCode,
                promoCode,
                homepage
            ));
        }

    }


    useEffect(() => {

        //if the confirm code state has been set to success, redirect to login page
        if (didJustRegisterUser) {
            props.history.push('/signin');
        }

        //preflight for LinkedIn
        preflightLinkedInAd();

    }, [props.history, dispatch, authUser, errors, didJustRegisterUser]);

    return (
        <React.Fragment>
            <div
                className="app-login-container-wide d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
                <div className="app-login-main-content">


                    <div className="app-logo-content-wide d-flex align-items-center justify-content-center">
                        <a className="logo-lg" href="https://www.breachbits.com" title="BreachBits">
                            <img src={BBLogo} alt="BreachBits Logo" title="Learn more about BreachBits at breachbits.com"/>
                        </a>
                    </div>



                    <div className="app-login-content-wide">
                        <div className={"row"}>
                            <div className=" col align-self-center">
                                <h1 className={""}><IntlMessages id="appModule.register"/></h1>
                                <h4 className={""}><IntlMessages id="appModule.register.details"/></h4>
                            </div>
                            <div className={"col mt-0 p-0"}>
                                <TextField
                                    label={<IntlMessages id="appModule.register.profileId"/>}
                                    fullWidth
                                    id="profileId"
                                    name="profileId"
                                    error={!!errors.profileId}
                                    onChange={(event) => setProfileId(event.target.value)}
                                    defaultValue={profileId}
                                    margin="normal"
                                    className="mt-0 my-sm-3"
                                    inputRef={register({
                                        // required: "A valid profile code is required. This was either provided by your organization or by BreachBits directly, usually via email." ,

                                    })}
                                    helperText={errors.profileId? errors.profileId?.message : "For existing company accounts. Usually sent via email."}
                                />
                            </div>
                        </div>

                        <div className="app-confirm-form">
                            <form>
                                <fieldset>
                                    <div className={"row"}>
                                        <div className={"col"}>

                                            <TextField
                                                label={<IntlMessages id="appModule.register.firstName"/>}
                                                fullWidth
                                                id="firstName"
                                                name="firstName"
                                                required
                                                error={!!errors.firstName}
                                                onChange={(event) => setFirstName(event.target.value)}
                                                defaultValue={firstName}
                                                margin="normal"
                                                className="mt-1 my-sm-3"
                                                inputRef={register({
                                                    required: "This field is required." ,

                                                })}
                                                helperText={errors.firstName?.message}
                                            />
                                            <TextField
                                                label={<IntlMessages id="appModule.register.lastName"/>}
                                                fullWidth
                                                id="lastName"
                                                name="lastName"
                                                required
                                                error={!!errors.lastName}
                                                onChange={(event) => setLastName(event.target.value)}
                                                defaultValue={lastName}
                                                margin="normal"
                                                className="mt-1 my-sm-3"
                                                inputRef={register({
                                                    required: "This field is required." ,

                                                })}
                                                helperText={errors.lastName?.message}
                                            />
                                            <TextField
                                                label={<IntlMessages id="appModule.register.email"/>}
                                                fullWidth
                                                id="email"
                                                name="email"
                                                required
                                                error={!!errors.email}
                                                onChange={(event) => setEmail(event.target.value)}
                                                defaultValue={email}
                                                margin="normal"
                                                className="mt-1 my-sm-3"
                                                inputRef={register({
                                                    required: "This field is required." ,
                                                    pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

                                                })}
                                                helperText={errors.email?.type === "pattern" && "Please enter a valid email address." || errors.email?.message}
                                            />
                                        </div>
                                        <div className={"col"}>
                                            <p className="mt-1 my-sm-3 align-self-center">

                                            </p>

                                            <TextField
                                                label={<IntlMessages id="appModule.register.username"/>}
                                                fullWidth
                                                id="username"
                                                name="username"
                                                required
                                                error={!!errors.username}
                                                onChange={(event) => setUsername(event.target.value)}
                                                defaultValue={username}
                                                margin="normal"
                                                className="mt-1 my-sm-3 align-self-center"
                                                inputRef={register({
                                                    required: "Please provide a unique username." ,

                                                })}
                                                helperText={errors.username? errors.username?.message : "You will log in with your username."}
                                            />
                                            <TextField
                                                label={<IntlMessages id="appModule.password"/>}
                                                fullWidth
                                                type="password"
                                                id="password"
                                                name="password"
                                                required
                                                error={!!errors.password}
                                                onChange={(event) => setPassword(event.target.value)}
                                                defaultValue={password}
                                                margin="normal"
                                                className="mt-1 my-sm-3 align-self-center"
                                                inputRef={register({
                                                    required: "This field is required." ,
                                                    // pattern: {
                                                    //     value: ^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[*.!@$%^&(){}[]:;<>,.?/~_+-=|\]).{8,32}$,
                                                    //     message: "Password must be more than 8 characters and contain three of the following: one uppercase letter, one lowercase letter, one number, and one special character.",
                                                    // },
                                                    maxLength : {
                                                        value: 40,
                                                        message: "No more than 40 characters are allowed."
                                                    },
                                                    minLength : {
                                                        value: 8,
                                                        message: "No fewer than 8 characters are allowed." //<IntlMessages id="form.validation.noMatch"/> will throw an endless rerender
                                                    },

                                                })}
                                                helperText={errors.password? errors.password?.message : "Between 8 - 40 characters."}
                                            />

                                        </div>
                                    </div>
                                    <div className={"mt-2"}>
                                        <h2>Service Level Agreement</h2>
                                        <div style={{overflow:"auto", border: "1px solid", height:200, padding:5}}>
                                            {sla}
                                        </div>

                                    </div>
                                    <br/>
                                    <FormControl>
                                        <FormControlLabel

                                            control={
                                                <Checkbox
                                                    id="signSLA"
                                                    name="signSLA"
                                                    checked={signSLA}
                                                    onChange={(event) => setSignSLA(event.target.checked)}
                                                    required
                                                    inputRef={register({
                                                        validate: value => value === true || "You must agree to the terms of the SLA",
                                                    })}
                                                />
                                            }
                                            label={<>Sign the <a href={"https://breachbits.com/sla"} target={"_blank"} rel={"noreferrer"} title={"Read the BreachBits Service Level Agreement in a new browser window."}>Service Level Agreement</a> <br/><small>Registration constitutes agreement to the SLA.</small></>}

                                        />
                                        <FormHelperText
                                            error={!!errors.signSLA}
                                        >
                                            {errors.signSLA? errors.signSLA?.message : " "}
                                        </FormHelperText>
                                    </FormControl>



                                    <br/>
                                    <br/>


                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                        <Button onClick={handleSubmit(onSubmit)}
                                                disabled={!!errors.firstName || !!errors.lastName || !!errors.email || !!errors.password || !!errors.profileId || !!errors.signSLA || !!errors.username}
                                                variant="contained" color="primary">
                                            <IntlMessages id="form.submit"/>
                                        </Button>
                                        {/*<Button onClick={() => {*/}
                                        {/*  dispatch(showAuthLoader());*/}
                                        {/*  dispatch(confirmEmailAction({confirmationCode}));*/}
                                        {/*}} variant="contained" color="primary">*/}
                                        {/*  <IntlMessages id="form.submit"/>*/}
                                        {/*</Button>*/}

                                        {token && //If user is logged in, they can go back to the dashboard.
                                        <Link to="/board/dashboard">
                                            <IntlMessages id="form.goBackHome"/>
                                        </Link>
                                        }
                                        {!token && //If user is not logged in, they can go back to the signin.
                                        <Link to="/signin">
                                            <IntlMessages id="form.goSignIn"/>
                                        </Link>
                                        }
                                    </div>

                                </fieldset>

                            </form>

                        </div>
                        <div id={"version"}> v. {`${pjson.version}`}</div>
                    </div>

                </div>


                {
                    loader &&
                    <div className="loader-view">
                        <CircularProgress/>
                    </div>
                }
                {/*{showMessage && NotificationManager.error(alertMessage, "Login Error", 10000)}*/}
                {/*<NotificationContainer/>*/}

            </div>
            <div className="break"> </div>
            {/*<div className={"app-login-subtitle"}>*/}
            {/*  <img src={require("assets/images/turn-the-tide-dark.png")} alt="breachbits" title="breachbits"/>*/}
            {/*</div>*/}
        </React.Fragment>
    );
};


export default RegisterUser;
